export function useVideoEditorClipActionsMenu() {
  const {
    editCustomFrame: editCustomFrameAction,
    deleteCustomFrame: deleteCustomFrameAction,
    deleteClip: deleteClipAction
  } = useVideoEditorActions();

  function confirmDeleteClip(clip) {
    useConfirmModal({
      heading: 'Delete Clip',
      message: 'Are you sure you want to delete this clip?',
      confirmText: 'Delete',
      color: 'red',
      confirmMethod: async () => {
        try {
          await deleteClipAction({clip});
        } catch (e) {
          useErrorToast().add();
        }
      }
    }).open();
  }

  function editCustomFrame(clip) {
    editCustomFrameAction({clip, frame: getTitleFrame(clip)});
  }

  function getTitleFrame(clip) {
    const frame = clip?.frames?.title;
    return frame?.design_project_id != null ? frame : null;
  }

  function confirmDeleteTitleFrame(clip) {
    const titleFrame = getTitleFrame(clip);
    if (!titleFrame) {
      return;
    }

    useConfirmModal({
      heading: 'Delete Title Cover',
      message: 'Are you sure you want to delete this title cover?',
      confirmText: 'Delete',
      color: 'red',
      confirmMethod: async () => {
        try {
          await deleteCustomFrameAction({
            clip,
            frame: titleFrame
          });
        } catch (e) {
          useErrorToast().add();
        }
      }
    }).open();
  }

  function getClipMenuItems(clip) {
    const hasAssociatedTitleFrame = Boolean(getTitleFrame(clip));

    const items = [
      {
        label: 'Delete',
        icon: COMMON_ICONS.delete,
        click: () => confirmDeleteClip(clip)
      },
      ...(hasAssociatedTitleFrame
        ? [{
            label: 'Delete Title Cover',
            icon: COMMON_ICONS.delete,
            click: () => confirmDeleteTitleFrame(clip)
          }]
        : []),
      {
        label: hasAssociatedTitleFrame ? 'Edit Title Cover' : 'Create Title Cover',
        icon: 'i-ri-image-edit-fill',
        click: () => editCustomFrame(clip)
      }
    ];

    return [items];
  }

  return {
    getClipMenuItems
  };
}
